export default __webpack_public_path__ + "img/14.asset.3fd8b948.jpeg";